import { render, staticRenderFns } from "./messageCenter.vue?vue&type=template&id=c37d6236&scoped=true&lang=pug"
import script from "./messageCenter.vue?vue&type=script&lang=ts"
export * from "./messageCenter.vue?vue&type=script&lang=ts"
import style0 from "./messageCenter.vue?vue&type=style&index=0&id=c37d6236&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c37d6236",
  null
  
)

export default component.exports